import { QUERY_KEYS } from '~/constants/react-query'
import { useAuthUser } from '~/hooks/useAuthUser'
import { useQueryWrapper } from '~/hooks/useQueryWrapper'
import { useServerRequests } from '~/hooks/useRequests'
import { FeatureCardProps } from '~/types/featureCards'

// Stable reference so the slot doesn't see a new array each pending render.
const EMPTY_FEATURE_CARDS: FeatureCardProps[] = []

// Published feature cards, newest first. Fails soft to an empty list.
export const useFeatureCards = () => {
  const { serverGetRequest } = useServerRequests()
  const { user: authUser } = useAuthUser()

  const { data, isPending } = useQueryWrapper<{ items: FeatureCardProps[] }>({
    queryKey: [QUERY_KEYS.FEATURE_CARDS],
    queryFn: async () => {
      const resp = await serverGetRequest<{ items: FeatureCardProps[] }>({
        path: '/api/user/feature-cards',
      })
      return resp?.data ?? { items: [] }
    },
    enabled: !!authUser,
  })

  return {
    featureCards: data?.items ?? EMPTY_FEATURE_CARDS,
    isSettled: !isPending,
  }
}
